import { render } from "./StepBirthInfo.vue?vue&type=template&id=ec63790c&scoped=true"
import script from "./StepBirthInfo.vue?vue&type=script&lang=js"
export * from "./StepBirthInfo.vue?vue&type=script&lang=js"

import "./StepBirthInfo.vue?vue&type=style&index=0&id=ec63790c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec63790c"]])

export default __exports__